import { SITE } from "../config/site";

const abs = (path) => `${SITE.domain}${path === "/" ? "" : path}`;

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE.brand,
    url: SITE.domain,
    description:
      "Independent dental information and patient-support platform helping international patients understand dental treatment in Vietnam.",
    email: SITE.email,
    sameAs: [SITE.social.facebook, SITE.social.instagram, SITE.social.linkedin].filter(Boolean),
  };
}

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE.brand,
    url: SITE.domain,
    inLanguage: ["en", "fr", "de"],
  };
}

export function webPageSchema({ name, description, path }) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name,
    description,
    url: abs(path),
    isPartOf: { "@type": "WebSite", name: SITE.brand, url: SITE.domain },
  };
}

// crumbs: [{ name, path }]
export function breadcrumbSchema(crumbs) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: abs(c.path),
    })),
  };
}

// faqs: [{ q, a }]
export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function articleSchema({ headline, description, path, image, author, reviewer, published, updated }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    description,
    image: image ? [image] : undefined,
    url: abs(path),
    datePublished: published,
    dateModified: updated || published,
    author: { "@type": "Person", name: author },
    reviewedBy: reviewer ? { "@type": "Person", name: reviewer } : undefined,
    publisher: {
      "@type": "Organization",
      name: SITE.brand,
      url: SITE.domain,
    },
    mainEntityOfPage: { "@type": "WebPage", "@id": abs(path) },
  };
}
